import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Rowbox from '../Common/Rowbox'
import { DECORATION_SIYI_TEAM_STYLE } from '@constant'
import { getRealPhotoStyle } from '@components/LocalMerchant/Decoration/util'

@observer
export default class extends Component {
  componentDidMount() {
    this.props.store.getRealPhotos()
  }

  render() {
    const { real_photos } = this.props.store

    return (
      <Rowbox
        type={DECORATION_SIYI_TEAM_STYLE}
        store={this.props.store}
        style={getRealPhotoStyle(real_photos)}
      />
    )
  }
}
